// extracted by mini-css-extract-plugin
export default {"wrapper":"standards_wrapper__FTBXV","inside":"standards_inside__yE28u","links":"standards_links__-OQjO"};